import { AxiosResponse } from "axios";
import { postRequest } from "helpers/axios";
import { API_ROUTES } from "helpers/constants/apis";
import { fetchIpInfo } from "../utils/fetchIpInfo";

interface UseSignRejectionProps {
  setIsSaving: (val: boolean) => void;
  // currentReduxState: any;
  currentReduxState: unknown;
}

export const useSignRejection = ({
  setIsSaving,
  currentReduxState,
}: UseSignRejectionProps) => {
  const handleSignRejection = async (commentText: string) => {
    const thankYouContainer = document.getElementById("thankyou-container") as HTMLElement;
    try {
      setIsSaving(true);

      // Show processing overlay
      thankYouContainer.innerHTML = `<div style="position:fixed;z-index:5;top:0;left:0;right:0;bottom:0;background-color:white;">
        <div style="display:flex;align-items:center;justify-content:center;height:100vh;width:100vw;flex-direction:column">
          <img src="/loading.gif" class="loading-logo-gif" />
          <span class="mb-3"><b>Processing Your Request</b></span>
        </div>
      </div>`;

      const signatoryUUID = (currentReduxState as any)?.basicInfoData?.uuidSignatory;
      const locationData = await fetchIpInfo();

      await postRequest(API_ROUTES.COMMON_HANDLESIGNREJECTION, false, {
        uuid_signatory: signatoryUUID,
        rejectionReason: commentText,
        location: locationData,
      });

      localStorage.clear();

      // Show rejection confirmation overlay
      thankYouContainer.innerHTML = `<div style="position:fixed;z-index:5;top:0;left:0;right:0;bottom:0;background-color:#F4EDE4;display:flex;justify-content:center;">
        <div class="parent-container-reject">
          <div class="child-container-reject">
            <div class="img-container-reject">
              <img src="/reject.svg" alt="reject svg" class="img-size-reject" />
              <p class="congrats-text-reject">Oops! you have rejected signature</p>
              <p class="closer-text-reject">We regret to see that you had rejected for signature. If this happens by mistake then please notify admin.</p>
            </div>
            <div class="footer-parent-reject">
              <div class="footer-child-reject">
                <span>Learn more about </span>
                <a href="https://www.eruditeworks.com" class="span-one">Erudite Docs</a>
              </div>
            </div>
          </div>
        </div>
      </div>`;
    } catch (err) {
      alert("Something went wrong. Please try again.");
      if (thankYouContainer) thankYouContainer.innerHTML = "";
    } finally {
      setIsSaving(false);
    }
  };

  return { handleSignRejection };
};
